import Model from './Model'

export default class Tour extends Model {
    resource()
    {
        return 'tours'
    }
}